<div class="surface-card p-4 shadow-2 border-round">
  <ng-template [ngIf]="isLoadingResults">
    <app-loading></app-loading>
</ng-template>
    <div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
      <div class="flex justify-start md:justify-start">
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroPratica" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICA <b>{{filtroPratica}}</b> DEL <b>BANDO 2</b> IN FASE <i>1</i></span>

        <span *ngIf="!isPresidioTIM && !filterIsSet && !filtroImpresa" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>1</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroInLavorazione && !filtroImpresa" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>1</i> IN LAVORAZIONE</span>
        <span *ngIf="!isPresidioTIM && filterIsSet && !filtroLotto && !filtroStatoInfratel && filtroImpresa && !filtroStatoFlowdy && !filtroStatoSopralluogo && !filtroRegione" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>1</i> DELL'IMPRESA <b>{{ragioneSocialeImpresa}}</b></span>
        <span *ngIf="!isPresidioTIM && !filtroLotto && !filtroStatoInfratel && filtroImpresa && filtroStatoFlowdy && !filtroStatoSopralluogo && !filtroRegione" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>1</i> DELL'IMPRESA <b>{{ragioneSocialeImpresa}}</b> E STATO <i>{{filtroStatoFlowdy}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && !filtroLotto && !filtroStatoInfratel && !filtroImpresa && !filtroStatoFlowdy && filtroStatoSopralluogo && filtroRegione" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>1</i> E STATO <i>{{filtroStatoSopralluogo.toUpperCase()}}</i> E REGIONE <i>{{filtroRegione.toUpperCase()}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && !filtroLotto && !filtroStatoInfratel && !filtroImpresa && filtroStatoFlowdy && !filtroStatoSopralluogo && !filtroRegione" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>1</i> E STATO <i>{{filtroStatoFlowdy}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && !filtroLotto && !filtroStatoInfratel && filtroImpresa && !filtroStatoFlowdy && filtroStatoSopralluogo && filtroRegione" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>1</i> DELL'IMPRESA <b>{{ragioneSocialeImpresa}}</b> E STATO <i>{{filtroStatoSopralluogo.toUpperCase()}}</i> E REGIONE <i>{{filtroRegione.toUpperCase()}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && !filtroLotto && !filtroStatoInfratel && filtroImpresa && !filtroStatoFlowdy && filtroStatoSopralluogo && !filtroRegione" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>1</i> DELL'IMPRESA <b>{{ragioneSocialeImpresa}}</b> E STATO <i>{{filtroStatoSopralluogo.toUpperCase()}}</i></span>

        <span *ngIf="isPresidioTIM" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE 1 IN CARICO AL PRESIDIO</span>
        <span *ngIf="!isPresidioTIM && filterIsSet && !filtroLotto && filtroStatoInfratel && !filtroLottoPerFase"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>1</i> E STATO <i>{{filtroStatoInfratel}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroLotto && !filtroStatoInfratel"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>1</i> E LOTTO  <i>{{filtroLotto}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroStatoInfratel && filtroLottoPerFase"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>1</i> E STATO <i>{{filtroStatoInfratel}}</i> E LOTTO  <i>{{filtroLottoPerFase}}</i></span>

       
         
      </div>
      <div class="flex justify-end md:justify-center">
      </div>
       
      <div class="flex justify-end md:justify-end">
        <button *ngIf="!isPM && !this.isDirigenteFirmaPacchetti && filterIsSet"
          pButton type="button" icon="pi pi-step-backward"
          pTooltip="Torna indietro" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#f0f4ff; color: #4f46e5; border-color: #4f46e5; font-size: 13px;"
          label="Indietro"
          (click)="goBack()" [disabled]="isLoadingResults || isDemo"
        ></button>
        <button *ngIf="!isPM && !this.isImpresa && !this.isDirigenteFirmaPacchetti"
        pButton type="button" icon="pi pi-reply"
        pTooltip="Aggiorna gli esiti della consegna ad Infratel" tooltipPosition="top"
        class="font-['Poppins'] mr-3"
        style="background-color:#fffdea; color: #05542b; border-color: #05542b; font-size: 13px;"
        label="Carica esiti"
        (click)="importaEsitiConsegna()" [disabled]="isLoadingResults || isDemo"
      ></button>
      <button button *ngIf="!isPM && !isImpresa && !isPresidioTIM"
          pButton type="button" icon="pi pi-cloud-download"
          pTooltip=" Report Preventivi Opere Extra" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#e3faf8; color: #0e192d; border-color: #3d64b3; font-size: 13px;"
          label="Report Preventivi O.E."
          (click)="scaricaReportPreventiviOpereExtra()" [disabled]="isLoadingResults"
        ></button>
        <button *ngIf="!isPM && praticheFiltrate && praticheFiltrate.length > 0"
          pButton type="button" icon="pi pi-cloud-download"
          pTooltip="Scarica export" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#e3faf8; color: #3d64b3; border-color: #3d64b3; font-size: 13px;"
          label="Scarica report"
          (click)="scaricaReportPratiche()" [disabled]="isLoadingResults"
        ></button>
      </div>
    </div>
 
 <!--[sortField]="'numero'" [sortOrder]="1"-->
            <div fxFlex="95%" class="mt-2">
                <p-table #praticheDT styleClass="p-datatable-sm" [loading]="isLoadingResults" [value]="praticheFiltrate" dataKey="id" [(selection)]="selectedPratica"
                [selectionPageOnly]="true" [rowHover]="true" [rows]="50" [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[50,100,200]" responsiveLayout="scroll" [paginator]="true"
                currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                [globalFilterFields]="['cui','codiceInvio','bando','tipoSede','tipoSedeEffettiva','denominazione','regione','comune','azienda', 'aziendaFase1','lotto','numeroOda',
                'statoFlowdyFase1','codiceStatoInfratelFase1','numeroOdaFase1']"
                >
                <ng-template pTemplate="caption">
                  <div class="flex align-items-center md:justify-content-between justify-content-between ">
                  
                    <div class="flex justify-start md:justify-start" style="align-items: stretch;">
                      <span class="p-input-icon-left mr-2">
                        <i class="pi pi-search"></i>
                        <input type="text" pInputText placeholder="Cerca" (input)="filtraPratiche($event)" [disabled]="isLoadingResults" style="height: 2.5rem;" />
                      </span>
                        <p-multiSelect 
                        *ngIf="!filterIsSet && !isImpresa"
                        styleClass="fieldFilterControl" 
                        [options]="imprese"
                        [showToggleAll]="false"
                        optionLabel="ragioneSociale"
                        optionValue="id"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Impresa"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.impresa"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniTipoSedeBando2"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Tipo sede"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.tipo"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniStatoInfratelFase1"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Stato Infratel"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.statoInfratel"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniStatoFlowdyFase1"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Stato Pratica"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.statoPratica"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniRegioneBando2"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Regione"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.regione"
                      />
                      <button *ngIf="filterIsSet || filterTabellaIsSet" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
                        style="background-color: #809cd4; border-color:#191a1b; color: #f9f9f9;font-size: 13px;" (click)="removeFilter()"
                        pTooltip="Rimuovi filtro" tooltipPosition="top" 
                      ></button>
                    </div>
                    <div class="flex justify-end md:justify-center">
                    </div>
                    <div class="flex justify-end md:justify-end">
                        <div class="flex align-items-center" *ngIf="!isPM && !filterIsSet">
                          <span class=" mr-2 text-900" style="font-size: small;">Mostra completate</span>
                          <p-inputSwitch [(ngModel)]="mostraPraticheCompletate" (ngModelChange)="onMostraCompletatiChange($event)"></p-inputSwitch>
                        </div>
                        <div class="flex align-items-center" *ngIf="isPM && !filterIsSet">
                          <span class=" mr-2 text-900" style="font-size: small;">Mostra approvati</span>
                          <p-inputSwitch [(ngModel)]="mostraPreventiviApprovati" (ngModelChange)="onMostraPreventiviApprovatiChange($event)"></p-inputSwitch>
                        </div>
                      </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                   <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">Azioni</th>
                   <th class="text-center font-['Poppins']" style="width: 1%"></th>
                   <th class="text-center font-['Poppins']" style="width: 5%"></th>
                   <!-- <th class="text-center font-['Poppins']" style="width: 10px"></th> -->
                   <th  pSortableColumn="cui" style="font-size: 10px; width: 16%;">
                        CUI
                    </th>
                    <th  pSortableColumn="cui" style="font-size: 10px; width: 10%;">
                      CODICE INVIO
                  </th>
                    <th  pSortableColumn="denominazione" style="font-size: 10px; width: 12%;">
                      SCUOLA
                    </th>
                     <th  pSortableColumn="tipoSedeEffettiva" style="font-size: 9px; width: 3%;">
                      TIPO
                    </th> 
                    <th class="text-center" style="font-size: 10px; width: 4%;">
                       COLOCATA
                    </th>
                   
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      STATO INFRATEL
                   </th>
                   <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">
                    STATO PRATICA
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px;width: 10%;">
                        IMPRESA
                    </th>
                   <!--  <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                        BANDO
                    </th>  -->
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">
                        LOTTO
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      ODA
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">
                      SOPRAL.
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">
                      OPERE EXTRA
                    </th>
                    <!-- <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;"></th> -->
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 8%;">
                      PREVENTIVO O.E.
                    </th>
                   
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      STATO PREVENTIVO
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">
                      PERMESSO ENTE
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      DATA INVIO
                    </th>
                    <th class="text-center font-['Poppins']" style="width: 1%"></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row>
                    <tr>
                      <td class="text-center" style="width: 10px;">
                        <button 
                          pButton type="button" style="color:rgb(39, 128, 15)"
                          icon="pi pi-ellipsis-v " class="p-button-rounded p-button-text small-icon" 
                          (click)="openCaricaAzioni($event,row)">
                        </button> 
                      </td>
                      <td class="text-center" >
                        <span *ngIf="row.showFase2" 
                          class="material-symbols-outlined small-icon"
                          [ngStyle]="{ 'color': '#EE8434' }"
                          [pTooltip]="'Pratica con PF no FASE1'" tooltipPosition="top">
                          assignment_late
                        </span>
                        <span *ngIf="checkSopralluogoPassato(row)" 
                          class="material-symbols-outlined small-icon"        
                          [ngStyle]="{ 'color': '#C42021'}"
                          [pTooltip]="getTooltipSopralluogoPassato(row)" tooltipPosition="top">
                          history_toggle_off
                        </span>
                      </td>
                    <!--   <td class="text-center" >
                        <span *ngIf="row.codiceStatoInfratelFase1==='1-2' && row.statoFlowdyFase1==='RESPINTA'" 
                          class="material-symbols-outlined small-icon"
                          [ngClass]="{'lampeggia': deveLampeggiare(row)}"
                          [ngStyle]="{ 'color': stiliService.getColoreRifiutataFase1(row) }"
                          [pTooltip]="getTooltipRifiutata(row)" tooltipPosition="top">
                          alarm
                        </span>
                      </td> -->
                      <td  class="text-center" >
                        <span *ngIf="(this.isImpresa || this.isPresidioSF) && checkShowActionIcons(row) && row.fileRETUploaded"                 class="material-symbols-outlined small-icon" style="color:#386FA4; cursor: pointer; " (click)="scaricaDoc(row, 'RET')"        tooltipPosition="top"   pTooltip="Scarica RET">description</span>
                        <span *ngIf="(this.isImpresa || this.isPresidioSF) && checkShowActionIcons(row) && row.fileVerbaleSopralluogoUploaded"  class="material-symbols-outlined small-icon" style="color:#EABE7C; cursor: pointer; " (click)="scaricaDoc(row, 'VERBALE')"    tooltipPosition="top"   pTooltip="Scarica Verbale di Sopralluogo">description</span>
                        <span *ngIf="(this.isImpresa || this.isPresidioSF) && checkShowActionIcons(row) && row.fileDUVRIUploaded"               class="material-symbols-outlined small-icon" style="color:#7C9885; cursor: pointer; " (click)="scaricaDoc(row, 'DUVRI')"      tooltipPosition="top"   pTooltip="Scarica DUVRI">description</span>

                      </td>

                      <td> 
                        <span class="text-uppercase font-bold font-['Poppins']" style="font-size: 8px; "
                          [pTooltip]="row.codiceMiur"
                          tooltipPosition="top"
                          >{{row.cui}}</span> 
                      </td>
                      <td class="text-left"> 
                        <span class="text-uppercase font-semibold font-['Poppins']" style="font-size: 7px;">{{row.codiceInvio}}</span> 
                      </td>
                      <td > 
                        <span class="text-uppercase font-['Poppins']" style="font-size: 7px; "
                          [pTooltip]="row.indirizzo+' - '+ row.comune.toUpperCase()"
                          tooltipPosition="top"
                          >{{row.denominazione}}</span> 
                      </td>
                      <td *ngIf="row.tipoSede === row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase" style="font-weight: bold; font-size: 8px;">{{row.tipoSede}}</span> </td>
                      <td *ngIf="row.tipoSede !== row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase" style="font-weight: bold; font-size: 8px;">{{row.tipoSede}} ({{row.tipoSedeEffettiva}})</span> </td>
 
                      <td class="text-center font-['Poppins']"> 
                        <ng-container *ngIf="row.colocata">
                          <ng-container *ngIf="row.colocataRuolo === 'PRINCIPALE'; else secondaryIcon">
                            <i class="material-icons text-green-700 colocata-icon" tooltipPosition="top" pTooltip="Scuola PRINCIPALE">done_outline</i>
                        </ng-container>
                        <ng-template #secondaryIcon>
                           <i class="material-icons text-blue-700 colocata-icon" tooltipPosition="top" pTooltip="Scuola riferita a {{getPrincipaleDiUnaColocata(row)}}">done_all</i>
                         </ng-template>
                      </ng-container>
                      </td>
                      <td class="text-center font-['Poppins']"> 
                        <p-tag
                                [value]="row.codiceStatoInfratelFase1 | uppercase"
                                [style]="{
                                  'background-color': stiliService.getStatoInfratelColor(row.codiceStatoInfratelFase1) ,
                                  'color': '#000000' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                  'font-size': '8px',
                                  'letter-spacing': '.3px;',
                                  
                                }"
                            ></p-tag>
                       </td>
                       <td class="text-center font-['Poppins']"> 
                        <span 
                          class="material-symbols-outlined small-icon"
                          [ngClass]="stiliService.getMaterialIconStatoFlowdy(row.statoFlowdyFase1, 1)"
                          [ngStyle]="{ 'color': stiliService.getColoreIconaStatoFlowdy(row.statoFlowdyFase1,1) }"
                          [pTooltip]="row.statoFlowdyFase1 | uppercase" tooltipPosition="top">
                          {{ stiliService.getMaterialIconStatoFlowdy(row.statoFlowdyFase1, 1) }}
                        </span>
                       <!--  <span *ngIf="checkIfDeliverable(row)"
                          class="material-symbols-outlined small-icon"
                          [style]="{
                            'color': '#83C48F' ,
                            'cursor': 'pointer',
                          }"
                          pTooltip="Consegna" tooltipPosition="top" (click)="consegnaPratica(row)">
                          send
                        </span> -->
                        
                       </td>
                      <td class="text-center font-['Poppins']"> 
                        <p-tag
                                [value]="row.aziendaFase1?row.aziendaFase1:row.azienda | uppercase"
                                [style]="{
                                  'background-color': '#326F6F' ,
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                  'font-size': '8px',
                                  'letter-spacing': '.3px;',
                                  'cursor': 'pointer',
                                }"
                                 (click)="filtraPerAzienda(row.aziendaFase1?row.aziendaFase1:row.azienda)"
                                 [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per azienda '+ (row.aziendaFase1?row.aziendaFase1:row.azienda)"
                                  tooltipPosition="top"
                            ></p-tag>
                       </td>
                      <!-- <td class="text-center font-['Poppins']">   
                        <p-tag
                              [value]="row.bando | uppercase"
                              [style]="{
                                'background-color': row.bando==='BANDO 2'?'cadetblue':'cornflowerblue' ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '10px',
                                'letter-spacing': '.3px;',
                                'cursor': 'pointer',
                              }"
                              (click)="filtraPerBando(row)"
                              [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per bando '+ row.bando"
                              tooltipPosition="top"
                              
                          ></p-tag>
                       </td> -->
                      <td class="text-center font-['Poppins']"> 
                        <p-tag [value]="row.lotto | uppercase"
                              [style]="{
                                'background-color': '#EBC66B' ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '8px',
                                'letter-spacing': '.3px;',
                                'cursor': 'pointer',
                              }"
                                  class="mr-1"
                                  (click)="filtraPerLotto(row.lotto)"
                                  [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per lotto '+row.lotto"
                                  tooltipPosition="top"
                        ></p-tag>
                      </td>
                      <td class="text-center font-['Poppins']"> 
                        <p-tag *ngIf="row.numeroOda || row.numeroOdaFase1" [value]="row.numeroOdaFase1?row.numeroOdaFase1:row.numeroOda"
                              [style]="{
                                'background-color': '#78C0E0' ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '8px',
                                'letter-spacing': '.3px;',
                              }"
                                  class="mr-1"
                                
                                  tooltipPosition="top"
                        ></p-tag>
                      </td>
                      <td class="text-center font-['Poppins']">
                        <span 
                          class="material-symbols-outlined small-icon"
                          [ngClass]="stiliService.getMaterialIconSopralluogoFase1(row)"
                          [ngStyle]="{ 'color': stiliService.getColoreIconaSopralluogoFase1(row) }"
                          [pTooltip]="getSopralluogoTooltip(row)" tooltipPosition="top">
                          {{ stiliService.getMaterialIconSopralluogoFase1(row) }}
                        </span>
                      </td>

                      <td class="text-center font-['Poppins']">
                        <span *ngIf="row.opereExtra"
                          class="material-symbols-outlined small-icon"
                          [ngClass]="stiliService.getMaterialIconOpereExtra(row)"
                          [ngStyle]="{ 'color': stiliService.getColoreIconaOpereExtra(row) }"
                          [pTooltip]="getOpereExtraTooltip(row)" tooltipPosition="top">
                          {{ stiliService.getMaterialIconOpereExtra(row) }}
                        </span>
                      </td>
                     <!--  <td>
                        <span *ngIf="row.filePreventivoUploaded" 
                        [style]="{  'cursor': 'pointer'}"
                         pTooltip='Scarica preventivo' tooltipPosition="top" class="material-symbols-outlined small-icon"
                         (click)="scaricaPreventivo(row)">ß
                         request_quote
                        </span>
                      </td> -->
                      <td class="text-center font-['Poppins']">
                        <span *ngIf="row.preventivo" [pTooltip]='getPreventivoTooltip(row)' tooltipPosition="top" 
                        class="text-uppercase font-semibold font-['Poppins']" style="font-size: 8px; "
                        >{{row.preventivo | formattaNumero}}</span>
                      </td>
                      <td class="text-center font-['Poppins']">
                          <span *ngIf="row.preventivo"
                          class="material-symbols-outlined small-icon"
                          [ngClass]="stiliService.getMaterialIconStatoPreventivo(row)"
                          [ngStyle]="{ 'color': stiliService.getColoreIconaStatoPreventivo(row) }"
                          [pTooltip]="getEsitoPreventivoTooltip(row)" tooltipPosition="top">
                          {{ stiliService.getMaterialIconStatoPreventivo(row) }}
                        </span>
                          
                    
                      </td>
                      <td class="text-center font-['Poppins']">
                        <span *ngIf="row.servePermessoEntePubblico"
                        class="material-symbols-outlined small-icon"
                        [ngClass]="'task'"
                        [ngStyle]="{ 'color': '#448FA3' }"
                        [pTooltip]="row.notePermessoEntePubblico" tooltipPosition="top">
                        {{ 'task' }}
                      </span>
                        
                      </td>
                      <td class="text-center font-['Poppins']">
                        <span *ngIf="row.dataInvioInfratelFase1 && row.codiceStatoInfratelFase1==='1-6'" class="text-center text-uppercase font-semibold font-['Poppins']" style="font-size: 8px; ">{{utilService.formattaDataDaTimestampFirestore(row.dataRispostaInfratelFase1)}}</span>
                        <span *ngIf="row.dataInvioInfratelFase1 && row.codiceStatoInfratelFase1!=='1-6'" class="text-center text-uppercase font-semibold font-['Poppins']" style="font-size: 8px; ">{{utilService.formattaDataDaTimestampFirestore(row.dataInvioInfratelFase1)}}</span>
                      </td>
                      <td class="text-center" >
                        <span *ngIf="checkIfInfoAreAvailable(row)"
                          class="material-symbols-outlined small-icon"
                          [ngStyle]="{ 'color': row?.ntwFC ? '#00BA63' : '#F17300', 'cursor': 'pointer' }"
                           (click)="mostraInfo(row)" 
                           [pTooltip]="'Mostra info '+ (row?.ntwFC ? '(CON NTW FC)' : '(NO NTW FC)')" tooltipPosition="top">
                          info
                        </span> 
                      </td>
                      </tr>
                </ng-template>
              </p-table> 
              <p-tieredMenu #menuAzioniTiered [popup]="true" [model]="menuAzioniItems"></p-tieredMenu>
            </div>
		</div>


<p-dialog [(visible)]="showDettagliPratica" appendTo="body" [modal]="true" header="Dettagli Pratica {{selectedPratica?selectedPratica.cui:''}}" [style]="{width: '50vw'}" [breakpoints]="{'960px': '75vw', '640px': '90vw'}">
  <div class="p-fluid">
        <div class="grid">
          <div class="col-6 font-bold">SDF Principale:</div>
          <div class="col-6">{{ selectedPratica?.sdfPrincipale }}</div>
          
          <div class="col-6 font-bold">SDF Backup:</div>
          <div class="col-6">{{ selectedPratica?.sdfBackup }}</div>
          
          <div class="col-6 font-bold">TGU FTTO Principale:</div>
          <div class="col-6">{{ selectedPratica?.tguFttoPrincipale }}</div>
          
          <div class="col-6 font-bold">TGU FTTO Backup:</div>
          <div class="col-6">{{ selectedPratica?.tguFttoBackup }}</div>
          
          <div class="col-6 font-bold">TGU Giga Principale:</div>
          <div class="col-6">{{ selectedPratica?.tguGigaPrincipale }}</div>
          
          <div class="col-6 font-bold">TGU Giga Backup:</div>
          <div class="col-6">{{ selectedPratica?.tguGigaBackup }}</div>
          
          <div class="col-6 font-bold">Impresa FC:</div>
          <div class="col-6">{{ selectedPratica?.impresaFC }}</div>
          
          <div class="col-6 font-bold">NTW FC:</div>
          <div class="col-6">{{ selectedPratica?.ntwFC }}</div>
        </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-center border-top-1 surface-border pt-2 ">
      <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showDettagliPratica = false" label="CHIUDI" class="p-button-outlined w-6 mr-2"></button>
    </div>
  </ng-template>
</p-dialog>

 <p-dialog [(visible)]="showDeliverConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
     <div class="flex flex-column align-items-center my-4">
        <span class="flex align-items-center justify-content-center bg-green-100 text-green-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
            <i class="pi pi-send text-5xl"></i>
        </span>
        <div class="font-medium text-2xl text-900">CONSEGNA</div>
    </div>
    <p class="line-height-3 p-0 m-0">
       Confermi di voler consegnare la FASE 1 della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
    </p>
    <ng-template pTemplate="footer">
        <div class=" border-top-1 surface-border pt-3 flex">
            <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showDeliverConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
            <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaConsegnaPratica()" label="CONFERMA" class="w-6 ml-2"></button>
        </div>
    </ng-template>
</p-dialog>  

<p-dialog [(visible)]="showAnnullaConsegnaConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-orange-100 text-orange-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="pi pi-send text-5xl"></i>
     </span>
     <div class="font-medium text-2xl text-900">ANNULLA CONSEGNA</div>
 </div>
 <p class="line-height-3 p-0 m-0">
    Confermi di voler annullare la consegna della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showAnnullaConsegnaConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaAnnullamentoConsegnaPratica()" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>

<p-dialog [(visible)]="showConfermaPreventivo" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-green-100 text-green-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="material-symbols-outlined small-icon" >request_quote</i>
     </span>
     <div class="font-medium text-2xl text-900">APPROVA PREVENTIVO</div>
 </div>
 <p class="line-height-3 p-0 m-0">
    Confermi di voler approvare il preventivo di <span style="font-weight: bold;">{{selectedPratica?selectedPratica.preventivo + ' €':''}} </span> per la pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showConfermaPreventivo = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaApprovaPreventivo()" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>  

<p-dialog [(visible)]="showResettaPratica" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-orange-100 text-orange\-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="material-symbols-outlined small-icon" >reset_settings</i>
     </span>
     <div class="font-medium text-2xl text-900">RESET PRATICA</div>
 </div>
 <p class="line-height-3 p-0 m-0 ">
    Confermi di voler <u>RESETTARE</u> la pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showResettaPratica = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaResetPratica()" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>  

<p-dialog [(visible)]="showFase1Approvata" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-green-100 text-green-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="material-symbols-outlined small-icon" >verified</i>
     </span>
     <div class="font-medium text-2xl text-900">FASE 1 APPROVATA</div>
 </div>
 <p class="line-height-3 p-0 m-0 ">
    Confermi di voler comunicare l'approvazione  della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span> da parte di INFRATEL?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showFase1Approvata = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaApprovazioneFase1()" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>  
<p-dialog [(visible)]="showDeletePraticaConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
      <span class="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
          <i class="pi pi-trash text-5xl"></i>
      </span>
      <div class="font-medium text-2xl text-900">ELIMINAZIONE</div>
  </div>
  <p class="line-height-3 p-0 m-0">
     Confermi di voler eliminare la pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}?</span>
  </p>
  <ng-template pTemplate="footer">
      <div class=" border-top-1 surface-border pt-3 flex">
          <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showDeleteConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
          <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaEliminazionePratica()" label="CONFERMA" class="w-6 ml-2"></button>
      </div>
  </ng-template>
</p-dialog> 

<p-dialog [(visible)]="showEliminaFileALTROConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-red-100 text-red-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="pi pi-eraser text-5xl"></i>
     </span>
     <div class="font-medium text-2xl text-900">ELIMINAZIONE FILE</div>
 </div>
 <p class="line-height-3 p-0 m-0">
    Confermi di voler eliminare tutti i file di tipo ALTRO della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showEliminaFileALTROConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="eliminataTuttiFileAltroCaricati(selectedPratica, 'ALTRO')" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>

<p-toast position="top-center"></p-toast>
<p-confirmDialog></p-confirmDialog>